'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _managed_contract_wrapper = require('./managed_contract_wrapper');

var _managed_contract_wrapper2 = _interopRequireDefault(_managed_contract_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoolsStoreWrapper = function (_ManagedContractWrapp) {
  (0, _inherits3.default)(PoolsStoreWrapper, _ManagedContractWrapp);

  function PoolsStoreWrapper() {
    (0, _classCallCheck3.default)(this, PoolsStoreWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (PoolsStoreWrapper.__proto__ || Object.getPrototypeOf(PoolsStoreWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(PoolsStoreWrapper, [{
    key: 'poolsAdded',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fromBlock, toBlock) {
        var contract;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.contract();

              case 2:
                contract = _context.sent;
                return _context.abrupt('return', contract.getPastEvents('PoolAdded', { fromBlock: fromBlock, toBlock: toBlock }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function poolsAdded(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return poolsAdded;
    }()
  }, {
    key: 'poolsRemoved',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(fromBlock, toBlock) {
        var contract;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.contract();

              case 2:
                contract = _context2.sent;
                return _context2.abrupt('return', contract.getPastEvents('PoolRemoved', { fromBlock: fromBlock, toBlock: toBlock }));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function poolsRemoved(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return poolsRemoved;
    }()
  }, {
    key: 'getPoolsCount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var contract;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.contract();

              case 2:
                contract = _context3.sent;
                return _context3.abrupt('return', contract.methods.getPoolsCount().call());

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPoolsCount() {
        return _ref3.apply(this, arguments);
      }

      return getPoolsCount;
    }()
  }, {
    key: 'getPool',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(idx) {
        var contract;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contract();

              case 2:
                contract = _context4.sent;
                return _context4.abrupt('return', contract.methods.pools(idx).call());

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getPool(_x5) {
        return _ref4.apply(this, arguments);
      }

      return getPool;
    }()
  }, {
    key: 'getPools',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(from, to) {
        var contract;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.contract();

              case 2:
                contract = _context5.sent;
                return _context5.abrupt('return', contract.methods.getPools(from, to).call());

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getPools(_x6, _x7) {
        return _ref5.apply(this, arguments);
      }

      return getPools;
    }()
  }, {
    key: 'getContractName',
    get: function get() {
      return 'poolsStore';
    }
  }]);
  return PoolsStoreWrapper;
}(_managed_contract_wrapper2.default); /*
                                       Copyright: Ambrosus Inc.
                                       Email: tech@ambrosus.io
                                       
                                       This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.
                                       
                                       This Source Code Form is “Incompatible With Secondary Licenses”, as defined by the Mozilla Public License, v. 2.0.
                                       */

exports.default = PoolsStoreWrapper;